import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SrvButton from "../../global/SrvButton";
import axios from "axios";
import ScrollContainer from 'react-indiana-drag-scroll'
import 'react-indiana-drag-scroll/dist/style.css'
import ErrorAdd from "../../../util/ErrorAdd";

function WidgetItemLabel({ idObject, idWidget, number, idItem, idItem2, onlyRead, idProject, editMode, added, idTab }) {

    /*
        idObject:
        1	Задача
        2	Регулярная задача
        6   Регулярная задача. Трекер
        3	Доска
        4	Проект
        5	Пользователь

        editMode - Режим редактирования виджетов
        added - true при событии добавления виджета 
        
        idItem  = ID_TaskR_Tracker    
        idItem2  = ID_TaskR  
    */


    const stateTask = useSelector((state) => state.taskList);//Задачи
    const stateTaskR = useSelector((state) => state.taskRlist);//Регулярные задачи.
    const stateTaskRTracker = useSelector((state) => state.taskRTrackerList);//Регулярные задачи. Трекер
    const stateBoardTask = useSelector((state) => state.boardTaskList);//Доски

    const [edit, setEdit] = useState(false);
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);

    const [data, setData] = useState([]);
    const [dataSet, setDataSet] = useState([]);//Данные для отправки на сервер
    const [labelListByObjectProject, setLabelListByObjectProject] = useState([]);

    useEffect(() => {
        setLog(null);

        if (idItem != null) {
            /*
            ID	Name
                1	Задача
                2	Регулярная задача
                3	Доска
                4	Проект
                5	Пользователь
                6	Регулярная задача. Трекер
            */

            if (idObject === 1) {
                setData(stateTask.listLabel.filter(a => a.ID_Item === idItem & a.id_tab === idTab));
                setDataSet(stateTask.listLabel.filter(a => a.ID_Item === idItem & a.id_tab === idTab).map((item) => { return item.ID_Label }));
            }
            else if (idObject === 2) {
                setData(stateTaskR.listLabel.filter(a => a.ID_Item === idItem & a.id_tab === idTab));
                setDataSet(stateTaskR.listLabel.filter(a => a.ID_Item === idItem & a.id_tab === idTab).map((item) => { return item.ID_Label }));
            }
            else if (idObject === 6) {
                setData(stateTaskRTracker.listLabel.filter(a => a.ID_Item === idItem2 & a.id_tab === idTab));
                setDataSet(stateTaskRTracker.listLabel.filter(a => a.ID_Item === idItem2 & a.id_tab === idTab).map((item) => { return item.ID_Label }));
            }
            else if (idObject === 3) {
                if (stateBoardTask.listLabel !== undefined) {
                    setData(stateBoardTask.listLabel.filter(a => a.ID_Item === idItem));
                    setDataSet(stateBoardTask.listLabel.filter(a => a.ID_Item === idItem).map((item) => { return item.ID_Label }));
                }
            }
        }
    }, [idItem, stateTask.listLabel, stateTaskR.listLabel, stateTaskRTracker.listLabel, stateBoardTask.listLabel]);

    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
                editHandler();
            }
        }
    }, [added]);

    function changeHandler(id, check) {
        if (check) {
            setDataSet([...dataSet, id]);
        }
        else {
            setDataSet(dataSet.filter(a => a !== id));
        }
    }

    function updateHandler() {
        setLoading(true);
        setLog(null);

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetLabelSet', { ID_Task: idItem, Labels: dataSet })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false)
                    }
                    else {
                        setLog(res.data.Error);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetLabelSet', { ID_TaskR: idItem, Labels: dataSet })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false)
                    }
                    else {
                        setLog(res.data.Error);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetLabelSet', { ID_Board_Task: idItem, Labels: dataSet })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false)
                    }
                    else {
                        setLog(res.data.Error);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    function editHandler() {
        axios.get('/api_tracker/label/listByObjectProject', { params: { ID_Object: idObject, ID_Project: idProject } })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLabelListByObjectProject(res.data.Data);
                    setEdit(true);
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <div>
            {data.length > 0 && (
                <div className="badge_block" >
                    <ScrollContainer className="scroll-container">
                        {data.map((item) => (
                            <div key={item.ID_Label} className="badge_item" style={{ backgroundColor: item.Color }} onClick={() => (onlyRead !== true && editHandler())}>
                                {item.Name}
                            </div>
                        ))}
                    </ScrollContainer>
                </div>
            )
            }
            {
                onlyRead === false && (
                    data.length === 0 && (
                        <div style={{ cursor: "pointer" }} onClick={() => editHandler()}>
                            <div className="mr-2 badge" style={{ backgroundColor: "gray", color: "white" }} >
                                + Добавить метки
                            </div>
                        </div>
                    )
                )
            }
            {
                edit === true &&
                (
                    <Modal show={edit} onHide={() => setEdit(false)} size="sm">
                        <Modal.Body>
                            <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            <div className="modal_title text-center">Выберите метки</div>
                            <div className="row mt-15">
                                {labelListByObjectProject.map((item) => (
                                    <div key={item.ID} className="col-md-12 d-flex" >
                                        {
                                            dataSet.filter(a => a === item.ID).length > 0 ?
                                                (
                                                    <>
                                                        <a href="" className="badge_item mb-2" style={{ backgroundColor: item.Color, color: "white", opacity: "50%", whiteSpace: 'normal' }} onClick={(e) => { e.preventDefault(); changeHandler(item.ID, false) }}>
                                                            {item.Name}
                                                        </a>
                                                        <FontAwesomeIcon icon={faCheck} className="ml-5 text-success text-bolder" />
                                                    </>
                                                )
                                                :
                                                (
                                                    <>
                                                        <a href="" className="badge_item  mb-2" style={{ backgroundColor: item.Color, color: "white", whiteSpace: 'normal' }} onClick={(e) => { e.preventDefault(); changeHandler(item.ID, true) }}>
                                                            {item.Name}
                                                        </a>
                                                    </>
                                                )
                                        }
                                    </div>
                                ))}
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-12 text-center">
                                    {log !== null && <div className="form_error text-center">{log}</div>}
                                    <SrvButton typeBtn="save" onClick={() => { updateHandler(data); }} loading={loading} size="lg" />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )
            }
        </div>
    )
}

export default WidgetItemLabel;